import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { DatesForm } from './sales-shipping-instructions-state/sales-shipping-instructions.model';

@Injectable({
  providedIn: 'root'
})
export class SalesShippingInstructionsService {


  private _apiUrl = environment.apiUrl;
  private _httpClient = inject(HttpClient);

  getSalesShippingInstructions() {
    // <SalesShippingInstructionDocument[]>
    return this._httpClient.get(`${this._apiUrl}/v1/sales-shipping-instructions/get-all-sales-shipping-instructions`);
  }

  getSalesShippingInstructionsTerms() {
    return this._httpClient.post(`${this._apiUrl}/v1/templates/get-template-form-values`, { type: 'salesShippingInstructions', stakeholders: [] });
  }

  getAvailableSalesConfirmations() {
    return this._httpClient.get(`${this._apiUrl}/v1/sales-shipping-instructions/get-available-sales-confirmations`);
  }

  getSalesConfirmationById(id: string) {
    return this._httpClient.get(`${this._apiUrl}/v1/sales-confirmations/get-sales-confirmation-by-id/${id}`);
  }

  getStockAvailable() {
    return this._httpClient.get(`${this._apiUrl}/v1/sales-shipping-instructions/stock-available`);
  }

  getSalesShippingInstructionsDocumentTemplate(body: any) {
    return this._httpClient.post(`${this._apiUrl}/v1/templates/get-filtered-values`, body);
  }

  //** Create */
  createSalesShippingInstruction(body: any) {
    return this._httpClient.post(`${this._apiUrl}/v1/sales-shipping-instructions/create-sales-shipping-instructions`, body);
  }

  //** Edit */

  getSalesShippingInstructionComponentsById(id: string, md5Checksum?: string, isCloneMode?: boolean) {
    return this._httpClient.get(`${this._apiUrl}/v1/sales-shipping-instructions/get-sales-shipping-instruction-components-by-id/${id}/${md5Checksum}/${isCloneMode}`);
  }

  updateSalesShippingInstruction(id: string, md5Checksum: string, body: any) {
    return this._httpClient.post(`${this._apiUrl}/v1/sales-shipping-instructions/update-sales-shipping-instruction/${id}/${md5Checksum}`, body);
  }

  updateSalesShippingInstructionDates(body: { _id: string; md5Checksum: string; dates: DatesForm }) {
    return this._httpClient.post(`${this._apiUrl}/v1/sales-shipping-instructions/update-sales-shipping-instruction-dates/${body._id}/${body.md5Checksum}`, body.dates);
  }

  //** Delete */

  deleteSalesShippingInstruction(payload: { _id: string, md5Checksum: string; }) {
    return this._httpClient.delete(`${this._apiUrl}/v1/sales-shipping-instructions/delete-sales-shipping-instruction/${payload._id}/${payload.md5Checksum}`);
  }

  deleteSalesShippingInstructionComponent(id: string) {
    return this._httpClient.delete(`${this._apiUrl}/v1/sales-shipping-instructions/delete-sales-shipping-instruction-component/${id}`);
  }

  //** Cell Renderer */

  getSalesShippingComponentsByParentId(parentId: string) {
    return this._httpClient.get(`${this._apiUrl}/v1/sales-shipping-instructions/get-sales-shipping-components-by-parent-id/${parentId}`);
  }

  //** Sales Shipping Instructions Status Functions */

  getDropdownsFilter(payload) {
    return this._httpClient.post(`${this._apiUrl}/v1/dropdown-options/get-dropdowns-filter`, payload);
  }

  updateSalesShippingInstructionStatus(body: { _id: string, status: string, statusChangeDate: string; }) {
    return this._httpClient.put(`${this._apiUrl}/v1/sales-shipping-instructions/update-sales-shipping-instruction-status/${body._id}`, body);
  }

  createPdf(id: string) {
    return this._httpClient.get(`${this._apiUrl}/v1/sales-shipping-instructions/pdf-ssi/${id}`,
      { responseType: 'blob' }
    );
  }

  exportSalesShippingInstructions() {
    return this._httpClient.get(`${this._apiUrl}/v1/sales-shipping-instructions/export-sales-shipping-instructions`, {
      responseType: "blob",
      observe: "response",
    });
  }
}

